import { Button } from "@sellar-io/components";
import { DeliveryChargeFulfillmentType } from "@sellar-io/api-v2/types";
import { useId } from "react";
import { useForm } from "react-hook-form";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useFulfillmentTypeContainerDeliveryChargeCreate } from "../../../../hooks/api/v2/fulfillmentTypeContainerDeliveryCharge/useFulfillmentTypeContainerDeliveryChargeCreate";
import { FulfillmentTypeContainerDeliveryChargeForm } from "../forms/FulfillmentTypeContainerDeliveryChargeForm";
import { FulfillmentTypeContainerDeliveryChargeFormType } from "../types/FulfillmentTypeContainerDeliveryCharge";

export const FulfillmentTypeContainerDeliveryChargeCreateDialog = ({
  active,
  onDismiss,
  fulfillmentType,
  fulfillmentTypeId,
}: {
  active: boolean;
  onDismiss: () => void;
  fulfillmentType: DeliveryChargeFulfillmentType;
  fulfillmentTypeId?: number;
}) => {
  const form = useForm<FulfillmentTypeContainerDeliveryChargeFormType>({
    shouldUseNativeValidation: true,
  });
  const formId = useId();

  const fulfillmentTypeContainerDeliveryChargeCreateMutation =
    useFulfillmentTypeContainerDeliveryChargeCreate();

  const onSubmit = (data: FulfillmentTypeContainerDeliveryChargeFormType) => {
    const { packQuantity, volume, displayUnit, containerType, charge } = data;
    const chargeInPence = charge * 100.0;

    fulfillmentTypeContainerDeliveryChargeCreateMutation.mutate(
      {
        packQuantity,
        volume,
        displayUnit,
        containerType,
        charge: chargeInPence,
        ...(fulfillmentTypeId
          ? {
              FulfillmentTypeId: fulfillmentTypeId,
              fulfillmentType: null,
            }
          : {
              FulfillmentTypeId: null,
              fulfillmentType,
            }),
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Add delivery charge"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        {fulfillmentTypeContainerDeliveryChargeCreateMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(
                fulfillmentTypeContainerDeliveryChargeCreateMutation.error,
              )?.response?.data.message ?? "Unknown error occurred."
            }
          />
        ) : null}
        <FulfillmentTypeContainerDeliveryChargeForm
          form={form}
          onSubmit={onSubmit}
          formId={formId}
        />
      </DialogContent>
      <DialogCTA>
        <Button
          type="submit"
          form={formId}
          loading={
            fulfillmentTypeContainerDeliveryChargeCreateMutation.isPending
          }
        >
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
